import { render, staticRenderFns } from "./Aquaregister.vue?vue&type=template&id=0ec21d05"
import script from "./Aquaregister.vue?vue&type=script&lang=js"
export * from "./Aquaregister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports